import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {PageRuleDTO} from '../model/pageRuleDTO';
import {RuleDTO} from '../model/ruleDTO';

@Injectable({
  providedIn: 'root'
})
export class RuleService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'rules';

  constructor(private http: HttpClient) {
  }

  getAll(pageNumber, pageSize, sortColumn, sortDirection) {
      const params = new HttpParams().append('page', pageNumber)
        .append('size', pageSize)
        .append('sort', `${sortColumn},${sortDirection}`);
    return this.http.get<PageRuleDTO>(`${this.path}`, {params: params});
  }

  save(rule: RuleDTO) {
    return this.http.post<RuleDTO>(this.path, rule);
  }

  delete(id) {
    return this.http.delete<void>(`${this.path}/${id}`);
  }
}
